export default {
  newDesign: true,
  title:
    "Qual desses perfis combina mais com seu filho ou sua filha: engenheiro, criador ou inventor? | Kodland",
  downtimeUrl: "https://www.kodland.org/pt",
  parameters: {
    landing_id: "BrQTS",
    segment: 42,
  },
  startPage: {
    title:
      "Qual desses perfis combina mais com seu filho ou sua filha: engenheiro, criador ou inventor?",
    subtitle:
      "Às vezes, tudo o que uma criança precisa para realmente desenvolver todo o seu potencial é encontrar o caminho que mais combina com ela.",
    image: {
      url: "/welcome/turkey_talent_pc.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/turkey_talent_mob.png",
      style: {
        width: "100%",
      },
    },
    button: "Vamos começar",
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "Obrigado por confiar em nossa plataforma educacional!",
    subtitle:
      "Infelizmente, tablets ou telefones não são adequados para assistir às nossas aulas. Ficaremos felizes em vê-lo em nossas aulas na próxima vez!",
  },
  quizRotateBySteps: {
    1: {
      question: "O que seu filho ou sua filha costuma fazer no tempo livre?",
      answers: [
        "🔧 Gosta de construir, montar coisas ou descobrir como elas funcionam",
        "🎀 Gosta de escolher cores, imagens, detalhes ou decidir como algo vai ficar",
        "📝 Gosta de inventar personagens, histórias, mundos ou suas próprias versões de jogos",
      ],
    },
    2: {
      question: "Em que tipo de tarefa ele/ela costuma se sair melhor?",
      answers: [
        "⚙️ Nas que exigem pensar, entender regras, resolver problemas ou encontrar padrões",
        "🖌️ Nas que exigem organizar, apresentar ou fazer algo ficar claro e bonito",
        "🚀 Nas que permitem propor ideias próprias ou criar algo original",
      ],
    },
    3: {
      question: "Pelo que seu filho ou sua filha costuma receber mais elogios?",
      answers: [
        "🧩 Por pensar com lógica, entender rápido e resolver problemas",
        "🖼️ Por fazer as coisas ficarem organizadas, claras e bonitas",
        "🌟 Pela criatividade, imaginação e ideias originais",
      ],
    },
    4: {
      question: "O que ele/ela faz por conta própria, sem que alguém precise lembrar?",
      answers: [
        "🛠️ Tentar entender algo, resolver, consertar ou melhorar",
        "🎯 Rever algo até que fique melhor, mais claro ou mais organizado",
        "📖 Inventar histórias, personagens, jogos ou mundos próprios",
      ],
    },
    5: {
      question: "O que realmente entusiasma seu filho ou sua filha?",
      answers: [
        "🔬 Descobrir respostas e entender como as coisas funcionam",
        "🎨 Criar algo bonito e mostrar para outras pessoas",
        "🦋 Inventar algo próprio: ideias, personagens ou histórias",
      ],
    },
    6: {
      question: "Qual característica descreve melhor seu filho ou sua filha?",
      answers: [
        "🧠 Gosta de entender como as coisas funcionam, perceber erros e fazer perguntas",
        "✨ Consegue passar bastante tempo melhorando algo até ficar exatamente como quer ",
        "🌈 Tem facilidade para criar ideias novas, histórias e soluções criativas",
      ],
    },
    7: {
      question: "O que ele/ela faz quando algo não dá certo de primeira?",
      answers: [
        "🔍 Tenta entender o que aconteceu e procura uma solução",
        "🔄 Continua ajustando até ficar como imaginou",
        "💡 Tenta de outro jeito ou inventa uma ideia nova",
      ],
    },
    8: {
      title: "Quantos anos tem o seu filho?",
      type: "age",
      button: "",
    },
    9: {
      title: "Parabéns!",
      typeInfo: "congrats",
      subtitle:
        "Clique em “Reservar uma aula” para concluir o cadastro.",
      button: "📆 Reservar uma aula",
    },
    10: {
      title: "Agende uma aula gratuita",
      type: "one-page-contacts",
      subtitle: "",
      button: "Quase lá! 🔥",
    },
    11: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    12: {
      typeInfo: "noQuestions",
      title: "Engenheiro! ⚙️",
      subtitle: "Seu filho ou sua filha não apenas usa as coisas — ele ou ela tenta entender como elas funcionam. De acordo com o resultado do quiz, há uma forte tendência ao pensamento de engenheiro: percebe conexões, quer entender a lógica por trás dos sistemas e consegue explorar novas tecnologias rapidamente. Sua aula experimental gratuita já foi reservada 🎉 Durante a aula ao vivo, o professor vai observar as habilidades técnicas e lógicas do seu filho ou da sua filha e ajudá-lo(a) a criar seu primeiro projeto digital, de acordo com o seu perfil. Se quiser continuar depois da aula, você pode garantir 30% de desconto no curso com o cupom  SARAH30. ",
      button: "Verificar preparação técnica",
      dynamicTypeInfo: [
        {
          condition: [{ step: "1", answer: "🔧 Gosta de construir, montar coisas ou descobrir como elas funcionam" }],
          data: {
            typeInfo: "noQuestions",
            title: "Engenheiro! ⚙️",
            subtitle: "Seu filho ou sua filha não apenas usa as coisas — ele ou ela tenta entender como elas funcionam. De acordo com o resultado do quiz, há uma forte tendência ao pensamento de engenheiro: percebe conexões, quer entender a lógica por trás dos sistemas e consegue explorar novas tecnologias rapidamente. Sua aula experimental gratuita já foi reservada 🎉 Durante a aula ao vivo, o professor vai observar as habilidades técnicas e lógicas do seu filho ou da sua filha e ajudá-lo(a) a criar seu primeiro projeto digital, de acordo com o seu perfil. Se quiser continuar depois da aula, você pode garantir 30% de desconto no curso com o cupom  SARAH30. ",
            button: "Verificar preparação técnica",
            imageLink: "/welcome/turkey_talent_v1.png",
          },
          
        },
        {
          condition: [{ step: "1", answer: "🎀 Gosta de escolher cores, imagens, detalhes ou decidir como algo vai ficar" }],
          data: {
            typeInfo: "noQuestions",
            title: "Criador! 🎨",
            subtitle: "Seu filho ou sua filha não apenas faz coisas bonitas — ele ou ela tenta expressar ideias de forma visual. De acordo com o resultado do quiz, há uma forte tendência ao pensamento criativo e voltado para design: percebe rapidamente cores, detalhes, harmonia e como uma ideia pode ser transmitida visualmente.Sua aula experimental gratuita já foi reservada 🎉 Durante a aula ao vivo, o professor vai observar a criatividade e as habilidades de pensamento visual do seu filho ou da sua filha e ajudá-lo(a) a criar seu primeiro projeto digital, de acordo com o seu perfil. Se quiser continuar depois da aula, você pode garantir 30% de desconto no curso com o cupom  SARAH30. ",
            button: "Verificar preparação técnica",
            imageLink: "/welcome/turkey_talent_v2.png",
          },
        },
        {
          condition: [{ step: "1", answer: "📝 Gosta de inventar personagens, histórias, mundos ou suas próprias versões de jogos" }],
          data: {
            typeInfo: "noQuestions",
            title: "Inventor! 💡",
            subtitle: "Seu filho ou sua filha não apenas brinca — ele ou ela cria as próprias regras, histórias e mundos. De acordo com o resultado do quiz, há uma forte tendência ao pensamento criativo: imagina com facilidade, encontra soluções fora do comum e consegue transformar ideias em projetos. Sua aula experimental gratuita já foi reservada 🎉 Durante a aula ao vivo, o professor vai observar os talentos naturais e os interesses do seu filho ou da sua filha e ajudá-lo(a) a criar seu primeiro projeto digital, de acordo com o seu perfil. Se quiser continuar depois da aula, você pode garantir 30% de desconto no curso com o cupom  SARAH30. ",
            button: "Verificar preparação técnica",
            imageLink: "/welcome/turkey_talent_v3.png",
          },
        },
        {
          default: true,
          data: {
            typeInfo: "noQuestions",
            title: "Engenheiro! ⚙️",
            subtitle: "Seu filho ou sua filha não apenas usa as coisas — ele ou ela tenta entender como elas funcionam. De acordo com o resultado do quiz, há uma forte tendência ao pensamento de engenheiro: percebe conexões, quer entender a lógica por trás dos sistemas e consegue explorar novas tecnologias rapidamente. Sua aula experimental gratuita já foi reservada 🎉 Durante a aula ao vivo, o professor vai observar as habilidades técnicas e lógicas do seu filho ou da sua filha e ajudá-lo(a) a criar seu primeiro projeto digital, de acordo com o seu perfil. Se quiser continuar depois da aula, você pode garantir 30% de desconto no curso com o cupom  SARAH30. ",
            button: "Verificar preparação técnica",
          },
        },
      ],
    },
    13: {
      title:
        "Obrigado 🎉 Faltam apenas alguns passos para concluir o cadastro",
      typeInfo: "pc-laptop",
      subtitle:
        "Por favor, observe que você precisará de um PC ou laptop funcional para a aula e que deve acompanhar seu filho durante toda a aula. Lembre-se de que a aula é individual e personalizada.",
      button: "O que mais?",
    },
    14: {
      title: "Verifique seu e-mail e WhatsApp antes da aula experimental 📞",
      typeInfo: "whatsapp",
      subtitle:
        "Enviaremos um lembrete 24 horas antes da aula e 2 horas antes da aula pediremos para você confirmar sua presença. É muito importante que mantenhamos contato para que a aula não seja cancelada.",
      button: "O que mais?",
    },
    15: {
      title: "A aula vai acontecer na nossa plataforma 💻",
      typeInfo: "classroom",
      subtitle:
        "Você vai receber um link e um código único pelo WhatsApp e e-mail. Basta clicar no link, ele vai te levar direto para a aula. Sem aplicativos extras, sem downloads.",
      button: "Entendi ✅",
    }
  },
};
